<template>
  <div>
    <div>
      <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            style="
              background: url('/static/img/default_header.png');
              background-position: top !important;
            "
          ></div>
          <!-- <img src="/static/img/video-main-banner.svg" /> -->
          <div class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5" v-if="editMode">
                {{ $t("project_edit") }}
              </div>
              <div class="text-subtitle-2 text-md-h5" v-else>
                {{ $t("create_project") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb v-if="!editMode" />
    <Breadcrumb
      v-else
      :trainingNameEdit="project.designations ? project.designations : null"
    />
    <div class="text-center">
      <v-dialog v-model="openDeleteDialog" width="500">
        <h4 class="v_title align_center">{{ $t("delete_project") }}</h4>
        <v-card-actions class="align_center">
          <v-btn
            @click="openDeleteDialog = false"
            outlined
            depressed
            tile
            class="cancelBtn mr-2 mb-2"
          >
            {{ $t("cancel") }}</v-btn
          >
          <v-btn
            @click="deleteProject()"
            outlined
            depressed
            tile
            class="savebutton mr-2 mb-2"
            v-show="$rights.includes('DELETE_SALESlIST_PROJECT')"
          >
            <img
              src="/static/img/popup-delete-icon.svg"
              class="popup-delete-icon"
            />
            {{ $t("delete") }}</v-btn
          >
        </v-card-actions>
      </v-dialog>
    </div>
    <div class="pt-8">
      <div class="row disablerow justify-content-between align-items-start">
        <div
          class="col-md-12 col-xl-9 innercreatetraining mb-3 mb-lg-0 pt-5 px-md-8 px-4 mx-0"
        >
          <div class="row disablerow justify-content-between">
            <!-- Put Content here -->
            <div class="col-md-12 mt-2 enter_learning_target_name_text">
              <v-select
                hide-details="auto"
                :items="sortedCountries"
                item-value="value"
                item-text="text"
                class="datainput justify-content-end align-self-center pb-1"
                dense
                outlined
                :label="$t('country') + '*'"
                v-model="project.country"
              ></v-select>
            </div>

            <div class="col-md-12 mt-2 enter_learning_target_name_text">
              <v-text-field
                hide-details="auto"
                class="datainput justify-content-end align-self-center pb-1"
                dense
                outlined
                :label="$t('project_name') + '*'"
                v-model="project.designations"
              ></v-text-field>
            </div>

            <div class="col-md-12 mt-2 enter_learning_target_name_text">
              <v-select
                hide-details="auto"
                :items="selectableSalesSource"
                class="datainput justify-content-end align-self-center"
                dense
                outlined
                :label="$t('salesSource')"
                v-model="project.salesSource"
              ></v-select>
            </div>

            <div class="col-md-12 mt-2 enter_learning_target_name_text">
              <v-text-field
                hide-details="auto"
                class="datainput justify-content-end align-self-center pb-1"
                dense
                outlined
                :label="$t('project_number')"
                v-model="project.projectNumber"
              ></v-text-field>
            </div>
          </div>
          <div class="col-md-12 lastBtnSubmit widAuto">
            <v-btn
              v-if="!editMode"
              @click="saveProject()"
              v-show="$rights.includes('CREATE_SALESLIST_PROJECT')"
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
              >{{ $t("save") }}</v-btn
            >
            <v-btn
              v-else
              @click="saveProject()"
              v-show="$rights.includes('UPDATE_SALESLIST_PROJECT')"
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
              >{{ $t("save") }}</v-btn
            >
            <v-btn
              @click="$routerBack()"
              outlined
              depressed
              tile
              class="cancelBtn mr-2 mb-2"
              >{{ $t("cancel") }}</v-btn
            >
            <v-btn
              v-show="editMode && $rights.includes('DELETE_SALESlIST_PROJECT')"
              @click="openDeleteDialog = true"
              outlined
              depressed
              tile
              class="deletebutton cancelBtn mr-2 mb-2"
            >
              <v-icon color="#444">mdi-delete</v-icon>
              {{ $t("delete") }}</v-btn
            >
          </div>
          <div class="text-right mb-4">
            <v-label> * {{ $t("mandatory_fields") }} </v-label>
          </div>
        </div>
        <div class="col-xl-3 px-0 pl-md-6 row pt-0 onlyContact">
          <div class="col-xl-12 right-side-block hide">
            <h4 class="text-uppercase">{{ $t("actions") }}</h4>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
            <v-btn
              v-show="editMode && $rights.includes('DELETE_SALESlIST_PROJECT')"
              @click="openDeleteDialog = true"
              outlined
              depressed
              tile
              class="deletebutton mr-2 mb-2"
            >
              <v-icon color="#444">mdi-delete</v-icon> {{ $t("delete") }}</v-btn
            >
            <v-btn
              @click="$routerBack()"
              outlined
              depressed
              tile
              class="backbutton mr-2 mb-2"
            >
              <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
            >
            <v-btn
              v-if="!editMode"
              @click="saveProject()"
              v-show="$rights.includes('CREATE_SALESLIST_PROJECT')"
              outlined
              depressed
              tile
              class="save mr-2 mb-2"
              >{{ $t("save") }}</v-btn
            >
            <v-btn
              v-else
              @click="saveProject()"
              v-show="$rights.includes('UPDATE_SALESLIST_PROJECT')"
              outlined
              depressed
              tile
              class="save mr-2 mb-2"
              >{{ $t("save") }}</v-btn
            >
          </div>
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "./custom/Card.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Card,
    Breadcrumb,
  },

  props: {
    //LearningTargetId: Number,
  },

  data() {
    return {
      editMode: false,
      languageTab: null,

      openDeleteDialog: false,
      projectId: null,
      project: {
        designations: null,
        country: "",
        salesSource: null,
        projectNumber: null,
      },
      countries: [],
      selectableSalesSource: [
        {
          value: "3P",
          text: "3P",
        },
        {
          value: "IC",
          text: "IC",
        },
        {
          value: "OE",
          text: "OE",
        },
        {
          value: "IV",
          text: "IV",
        },
      ],
    };
  },
  computed: {
    languageTabsNew() {
      return this.$root.languageTabsNew;
    },
    sortedCountries() {
      // Sort and transform countries data
      return this.countries
        .map((country) => ({
          text: this.$t(country),
          value: country,
        }))
        .sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
    },
  },

  mounted() {
    if (this.$route.query.projectId) {
      this.editMode = true;
      this.projectId = this.$route.query.projectId;
      this.fetchProjectByID(this.projectId);
    }
    this.fetchCountries();
  },

  methods: {
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    lowerCaseMapKeys(map) {
      for (var key in map) {
        if (map.hasOwnProperty(key)) {
          if (key == key.toUpperCase()) continue;
          map[key.toUpperCase()] = map[key];
          delete map[key];
        }
      }
    },
    fetchCountries() {
      this.$axios
        .get("/api/location/countries")
        .then((response) => {
          this.countries = response.data;
        })
        .catch(this.onError);
    },
    fetchProjectByID() {
      var _this = this;
      this.$axios
        .get("/api/project/fetch-project/" + this.projectId)
        .then(function (response) {
          _this.project = response.data;
          _this.project.designations = _this.project.designations;
        })
        .catch(this.onError);
    },

    saveProject() {
      var _this = this;
      var project = {};
      project = Object.assign(project, this.project);

      if (this.$isStringEmptyOrNull(project.country)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("country") }));
        return;
      }

      if (this.$isStringEmptyOrNull(project.designations)) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("project_name") })
        );
        return;
      }

      if (this.projectId === null) {
        this.$axios
          .post("/api/project/save", project)
          .then(function (response) {
            _this.$noty.success(_this.$t("project_save_success"));
            _this.$routerBack();
          })
          .catch(this.onError);
      } else {
        this.$axios
          .put("/api/project/edit/" + this.projectId, this.project)
          .then(function (response) {
            _this.$t("project_edit_success");
            _this.$routerBack();
          })
          .catch(this.onError);
      }
    },

    deleteProject() {
      if (this.projectId == null) {
        console.error("You are not editing an existing learning target.");
        return;
      }

      var _this = this;

      this.$axios
        .delete("api/project/" + this.projectId)
        .then(function (response) {
          _this.$noty.success(_this.$t("project_delete_sucess"));
          _this.$router.push("/projects");
        })
        .catch(this.onError);
    },

    onFinally() {
      showLoadingCircle(false);
    },
  },
};
</script>
